import { render, staticRenderFns } from "./HOC.vue?vue&type=template&id=664a1760&scoped=true"
import script from "./HOC.vue?vue&type=script&lang=js"
export * from "./HOC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a1760",
  null
  
)

export default component.exports